import type { FilterOptions } from "~/types";

export interface DeviceTypeDeclinations {
  deviceDeclinations: string[];
}
export type DeviceTypeDeclinationMap = Record<string, DeviceTypeDeclinations>;

export const typeOptions: FilterOptions = {
  label: "filters.type",
  options: [
    {
      value: "S4G-PL",
      label: "S4G-PL",
    },
  ],
};

// This is a temporary fix
// when implement dynamic types this can be removed
export const firmwareTypeOptions: FilterOptions = {
  label: "filters.type",
  options: [
    {
      value: "S4G-PL",
      label: "S4G-PL",
    },
    {
      value: "LPP4",
      label: "LogUp",
    },
  ],
};

export const deviceTypeDeclinationMap: DeviceTypeDeclinationMap = {
  HPP21: {
    deviceDeclinations: [],
  },
  LPP4: {
    deviceDeclinations: [],
  },
  "S4G-PL": {
    deviceDeclinations: ["S4GT", "S4TH", "S4W"],
  },
};
